const marquees = document.querySelectorAll(".marquee.swiper");
marquees.forEach(marquee => {
    const swiper = new Swiper(marquee, {
  slidesPerView: "auto",
  spaceBetween: 0,
  loop: true,
  speed: 16000,
  allowTouchMove: false,
  autoplay: {
    delay: 1,
    disableOnInteraction: false
  }
});
});